




























































































































































































































































































































































import { Component, Vue, Ref, Watch, Prop } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import ProjectCard from '@/components/projectcard/projectcard.component.vue';
import ProjectModal from '@/components/projectmodal/projectmodal.component.vue';
import { Camera } from '@/models/camera';
import { City } from '@/models/city';
import { Project } from '@/models/project';
import { User } from '@/models/user';
// @ts-ignore: no d.ts file
import { vTeleport } from '@desislavsd/vue-teleport';
import * as Plotly from 'plotly.js';
import { ModeBarDefaultButtons } from 'plotly.js';
import { Storage } from 'aws-amplify';
import { Logger } from 'aws-amplify';
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css'; // Re-uses images from ~leaflet package
import 'leaflet-defaulticon-compatibility';
import L from 'leaflet';
import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';
import { offset } from '@floating-ui/dom';
import { title } from 'process';

enum SortType {
  Recent = 'recent',
  City = 'city',
}

enum FilterType {
  All = 'all',
  Active = 'active',
  Inactive = 'inactive',
  NoPhoto48 = 'noPhoto48',
}

@Component({
  components: {
    ProjectCard,
    ProjectModal,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    vTeleport,
  },
})
export default class ProjectList extends Vue {
  @Ref('project-modal') readonly projectModal!: ProjectModal;
  @Prop({ type: String, default: null }) readonly logoUrl!: string | null;
  @State('user', { namespace: 'profile' }) private user!: User;

  @State('projects', { namespace: 'projects' }) private allProject!: Project[];
  @Getter('filter', { namespace: 'projects' }) private filterProject!: (search: string) => Project[];

  private projects: Project[] = [];
  private search = '';
  private displayedProjectsCount = 20; // Nombre initial de projets à afficher

  private url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  private attribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
  private center: [number, number] = [48.858093, 2.294694]; // Coordinates for Paris, France
  private zoom = 4;
  private showMap = false; // Set to true to display the map by default
  private showMosaicAndList = true;
  private satelliteView = false;
  private mapButtonText = 'Map';
  private cardsPerRow = this.calculateCardsPerRow();
  public imageUrls: { [key: string]: string } = {};
  private imagesLoaded = 0;
  private readonly FilterType = FilterType;
  private filter: FilterType = FilterType.All;
  public defaultImageUrl = 'https://via.placeholder.com/150';
  private selectedOwner: string | null = null;
  public showGraph = false;
  private showTypeFilter = false;
  private selectedTypes: string[] = ['Tout', 'IA', 'Live'];
  private oldSelected: string[] = [];
  private windowWidth: number = window.innerWidth;
  private intervalId: ReturnType<typeof setInterval> | null = null;
  private resetTrigger = 0;
  private updateKey = 0;

  public get owners(): User[] {
    const ownerMap = new Map<string, User>();

    this.allProject.forEach((project) => {
      // Accéder au propriétaire de chaque projet
      const owner = project.owner;
      if (owner && owner.id && !ownerMap.has(owner.id)) {
        const fullOwner: User = {
          ...owner,
          createdAt: new Date(), // Remplacez par une valeur valide si nécessaire
          firstLogin: false, // Ajoutez des valeurs par défaut
          birthday: undefined,
          company: undefined,
          function: undefined,
          acceptedCgu: false,
          acceptedNewslettre: false,
          notification: false,
          locale: owner.locale,
          volumeData: undefined,
        };
        ownerMap.set(owner.id, fullOwner);
      }
    });

    return Array.from(ownerMap.values());
  }

  private get iaProjectCount(): number {
    return this.allProject.filter((project) => project.cameras?.some((cam) => cam.detectionia === true)).length;
  }

  private get liveProjectCount(): number {
    return this.allProject.filter((project) => project.cameras?.some((cam) => cam.live === true)).length;
  }

  private get toutProjectCount(): number {
    return this.allProject.filter(
      (project) => !project.cameras?.some((cam) => cam.detectionia === true || cam.live === true)
    ).length;
  }

  private get displayedProjectsForList(): Project[] {
    return this.projects.slice(0, this.displayedProjectsCount);
  }

  /* masaïc view variable */
  private readonly SortType = SortType;
  private sort: SortType = SortType.Recent;

  /* list view variable */
  private fields = [
    { key: 'createdAt', label: "Date d'installation", sortable: true },
    { key: 'endDate', label: 'Date de Fin', sortable: true },
    { key: 'name', label: 'Nom du projet', sortable: true },
    { key: 'lastPhotoDate', label: 'Date de la dernière photo', sortable: true, thStyle: { width: '280px' } },
    { key: 'status', label: 'Statut', sortable: true, thStyle: { width: '100px' } },
    {
      key: 'city',
      label: 'Nom de la ville',
      formatter: (value: City) => value.value,
      sortable: true,
      sortByFormatted: true,
      thStyle: { width: '300px' },
    },
    {
      key: 'administrator',
      label: 'Administrateur',
      formatter: (value?: User[]) => (value ? value.length : 0),
      sortable: true,
      sortByFormatted: true,
    },
    {
      key: 'guest',
      label: 'Invités',
      formatter: (value?: User[]) => (value ? value.length : 0),
      sortable: true,
      sortByFormatted: true,
      thStyle: { width: '100px' },
    },
    {
      key: 'cameras',
      label: 'Caméras',
      formatter: (value?: Camera[]) => (value ? value.length : 0),
      sortable: true,
      sortByFormatted: true,
      thStyle: { width: '100px' },
    },
    { key: 'id', label: 'Réglages', thStyle: { width: '100px' } },
  ];

  private sortBy = 'createdAt';
  private sortDesc = true;

  private resetDisplayedProjectsCount(): void {
    this.displayedProjectsCount = 20;
  }

  private onFilterChangeStatus(value: FilterType) {
    if (value === FilterType.All) {
      this.projects = this.allProject.slice(0);
    } else if (value === FilterType.Active) {
      this.projects = this.allProject.filter((project) =>
        project.cameras.some((camera) => camera.apiFetchInterval !== -1)
      );
    } else if (value === FilterType.Inactive) {
      this.projects = this.allProject.filter((project) =>
        project.cameras.every(
          (camera) => camera.apiFetchInterval === -1 && camera.optic !== '4624x3472' && camera.optic !== '5496x3672'
        )
      );
    } else if (value === FilterType.NoPhoto48) {
      const threshold = Date.now() - 48 * 60 * 60 * 1000; // 48 heures en millisecondes
      this.projects = this.allProject.filter(
        (project) =>
          project.status !== 'Terminé' && // Le projet ne doit pas être terminé
          project.cameras.some((camera) => {
            // Vérifier que la caméra possède une dernière photo et que celle-ci est plus ancienne que 48 heures
            if (!camera.lastPhoto?.createdAt || new Date(camera.lastPhoto.createdAt).getTime() >= threshold) {
              return false;
            }
            // La caméra doit répondre à l'une des conditions suivantes :
            // - apiFetchInterval différent de -1
            // - optic égal à "4624x3472" ou "5496x3672"
            return camera.apiFetchInterval !== -1 || camera.optic === '4624x3472' || camera.optic === '5496x3672';
          })
      );
    }
    this.onSortChange(this.sort);
    this.resetDisplayedProjectsCount();
  }

  private onSelectedTypesChange(newVal: string[]): void {
    // Autoriser que la liste soit vide => pas de projet
    // si vous préférez forcer au moins 1, il faudrait un petit contrôle

    // On met simplement à jour
    this.selectedTypes = newVal;
    this.oldSelected = [...newVal];
  }

  private handleClickOutside(event: MouseEvent): void {
    const dropdown = this.$refs.typeFilterDropdown as HTMLElement;
    if (dropdown && !dropdown.contains(event.target as Node)) {
      this.showTypeFilter = false; // Ferme le menu si le clic est à l'extérieur
    }
  }

  private toggleTypeFilter(): void {
    this.showTypeFilter = !this.showTypeFilter;
    if (this.showTypeFilter) {
      // Ajouter un écouteur de clic global lorsqu'on ouvre le menu
      document.addEventListener('click', this.handleClickOutside);
    } else {
      // Supprimer l'écouteur si le menu est fermé
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  private get displayedProjects(): Project[] {
    // Référence à resetTrigger pour forcer le recalcul à chaque mise à jour
    this.resetTrigger;

    // Si aucun type n'est sélectionné, retourner un tableau vide
    if (this.selectedTypes.length === 0) {
      return [];
    }

    // Commencer avec une nouvelle référence de this.projects pour garantir la réactivité
    let filteredProjects = [...this.projects];

    // Filtrer par statut (actif ou terminé)
    if (this.filterStatus === 'active') {
      filteredProjects = filteredProjects.filter((p) => p.status !== 'Terminé');
    } else if (this.filterStatus === 'completed') {
      filteredProjects = filteredProjects.filter((p) => p.status === 'Terminé');
    }

    // Filtrer par propriétaire sélectionné
    if (this.selectedOwner) {
      if (this.selectedOwner === 'others') {
        const excludedIds = [
          'd71996b1-800f-4ec8-8f20-c1a341198f62',
          '5a308ace-0010-404d-9b75-b68d60cf0526',
          '2048cf37-41ca-4b54-8bee-66d963d57f98',
          'f55592f0-cda7-4243-8fc5-add96d5d53db',
        ];
        filteredProjects = filteredProjects.filter(
          (project) => project.owner && !excludedIds.includes(project.owner.id)
        );
      } else {
        filteredProjects = filteredProjects.filter((project) => project.owner?.id === this.selectedOwner);
      }
    }

    // Filtrer par recherche (nom, tags, propriétaire)
    const searchLower = this.search.toLowerCase();
    filteredProjects = filteredProjects.filter(
      (p) =>
        p.name.toLowerCase().includes(searchLower) ||
        p.tags?.some((tag) => tag.toLowerCase().includes(searchLower)) ||
        p.owner?.email?.toLowerCase().includes(searchLower)
    );

    // Filtrer par types sélectionnés (Tout, IA, Live)
    const hasIA = this.selectedTypes.includes('IA');
    const hasLive = this.selectedTypes.includes('Live');
    const hasTout = this.selectedTypes.includes('Tout');
    const countSelected = [hasTout, hasIA, hasLive].filter(Boolean).length;

    if (countSelected === 3) {
      // Tous les projets (Tout + IA + Live)
    } else if (countSelected === 1 && hasTout) {
      // Projets sans IA ni Live
      filteredProjects = filteredProjects.filter(
        (project) => !project.cameras?.some((cam) => cam.detectionia === true || cam.live === true)
      );
    } else if (countSelected === 1 && hasIA) {
      // Projets avec au moins une caméra IA
      filteredProjects = filteredProjects.filter((project) => project.cameras?.some((cam) => cam.detectionia === true));
    } else if (countSelected === 1 && hasLive) {
      // Projets avec au moins une caméra Live
      filteredProjects = filteredProjects.filter((project) => project.cameras?.some((cam) => cam.live === true));
    } else if (countSelected === 2 && hasIA && hasLive) {
      // Projets avec au moins une caméra IA et une caméra Live
      filteredProjects = filteredProjects.filter((project) => {
        const hasIaCam = project.cameras?.some((cam) => cam.detectionia === true);
        const hasLiveCam = project.cameras?.some((cam) => cam.live === true);
        return hasIaCam && hasLiveCam;
      });
    } else if (countSelected === 2 && hasTout && hasLive) {
      // Projets sans IA
      filteredProjects = filteredProjects.filter(
        (project) => !project.cameras?.some((cam) => cam.detectionia === true)
      );
    } else if (countSelected === 2 && hasTout && hasIA) {
      // Projets sans Live
      filteredProjects = filteredProjects.filter((project) => !project.cameras?.some((cam) => cam.live === true));
    } else {
      // Aucun projet si aucune case n'est cochée
      return [];
    }

    // Trier les projets par date de création (les plus récents en premier)
    filteredProjects.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

    // Limiter le nombre de projets affichés avec lazy loading
    return filteredProjects.slice(0, this.displayedProjectsCount);
  }

  private filterStatus = 'all'; // Valeur par défaut : afficher tous les projets

  public get filteredProjects(): Project[] {
    let filtered = this.allProject;

    if (this.filterStatus === 'active') {
      filtered = filtered.filter((project) => project.status === 'En cours');
    } else if (this.filterStatus === 'completed') {
      filtered = filtered.filter((project) => project.status === 'Terminé');
    }

    return filtered.filter((project) => project.name.toLowerCase().includes(this.search.toLowerCase()));
  }

  public get activeProjectsCount(): number {
    return this.allProject.filter((project) => project.status === 'En cours').length;
  }

  public get inactiveProjectsCount(): number {
    const threshold = Date.now() - 48 * 60 * 60 * 1000; // 48 heures en millisecondes
    return this.allProject.filter(
      (project) =>
        project.status !== 'Terminé' && // Exclure les projets terminés
        project.cameras.every(
          (camera) => camera.apiFetchInterval === -1 && camera.optic !== '4624x3472' && camera.optic !== '5496x3672'
        ) &&
        project.cameras.some(
          (camera) =>
            camera.lastPhoto?.createdAt
              ? new Date(camera.lastPhoto.createdAt).getTime() < threshold // Dernière photo plus vieille que 48h
              : true // Si pas de dernière photo, considérer comme inactif
        )
    ).length;
  }

  public get completedProjectsCount(): number {
    return this.allProject.filter((project) => project.status === 'Terminé').length;
  }

  public get activeProjects(): number {
    const completedProjects = this.allProject.filter((project) => project.status === 'Terminé').length;
    return this.allProject.length - completedProjects;
  }

  public get defectiveProjectsCount(): number {
    const threshold = Date.now() - 48 * 60 * 60 * 1000; // 48 heures en millisecondes
    return this.allProject.filter(
      (project) =>
        project.status !== 'Terminé' && // Le projet ne doit pas être terminé
        project.cameras.some((camera) => {
          // Vérifier que la caméra possède une dernière photo et que celle-ci est plus ancienne que 48 heures
          if (!camera.lastPhoto?.createdAt || new Date(camera.lastPhoto.createdAt).getTime() >= threshold) {
            return false;
          }
          // La caméra doit répondre à l'une des conditions suivantes :
          // - apiFetchInterval différent de -1
          // - optic égal à "4624x3472" ou "5496x3672"
          return camera.apiFetchInterval !== -1 || camera.optic === '4624x3472' || camera.optic === '5496x3672';
        })
    ).length;
  }

  public get totalProjects(): number {
    return this.allProject.length;
  }

  public get projectsByMonth() {
    const months = ['Jan', 'Fév', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Dec'];

    const dates = this.allProject.map((project) => new Date(project.createdAt));
    const projectsByMonth: { [key: string]: number } = {};
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();

    const camerasByMonth: { [key: string]: number } = {};
    this.allProject.forEach((project) => {
      if (project.id !== '0ec8c17e-b539-4762-8d71-d33f34a12aa0') {
        const projectDate = new Date(project.createdAt);
        const key = `${projectDate.getFullYear()}-${projectDate.getMonth()}`;
        const camerasCount = project.cameras?.length || 0; // Nombre de caméras pour ce projet
        camerasByMonth[key] = (camerasByMonth[key] || 0) + camerasCount;
      }
    });

    for (let i = currentMonth - 1; i <= currentMonth; i++) {
      const key = `${currentYear}-${i}`;
      if (!projectsByMonth[key]) {
        projectsByMonth[key] = 0; // Pas de projets, mais inclure le mois
      }
    }

    dates.forEach((date) => {
      const key = `${date.getFullYear()}-${date.getMonth()}`;
      projectsByMonth[key] = (projectsByMonth[key] || 0) + 1;
    });

    const sortedKeys = Object.keys(projectsByMonth).sort((a, b) => {
      const [yearA, monthA] = a.split('-').map(Number);
      const [yearB, monthB] = b.split('-').map(Number);
      return yearA !== yearB ? yearA - yearB : monthA - monthB;
    });
    let cumulativeCount = 0;
    const cumulativeData = sortedKeys.map((key) => {
      cumulativeCount += projectsByMonth[key];
      return { key, count: projectsByMonth[key], cumulative: cumulativeCount };
    });

    const cumulativeCamerasData: number[] = [];
    let cumulativeCamerasCount = 0;

    sortedKeys.forEach((key) => {
      cumulativeCamerasCount += camerasByMonth[key] || 0;
      cumulativeCamerasData.push(cumulativeCamerasCount);
    });

    const labels = cumulativeData.map((item) => {
      const [year, month] = item.key.split('-').map(Number);
      return `${months[month]} ${year}`;
    });

    const counts = cumulativeData.map((item) => item.count);
    const cumulatives = cumulativeData.map((item) => item.cumulative);
    const camerasCounts = sortedKeys.map((key) => camerasByMonth[key] || 0);

    return { labels, counts, cumulatives, camerasCounts, cumulativeCamerasData };
  }

  private toggleGraph(): void {
    // Inverse la valeur de showGraph
    this.showGraph = !this.showGraph;

    // Si on vient de l'activer
    if (this.showGraph) {
      this.$nextTick(() => {
        this.renderGraph();
      });
    }
  }

  private renderGraph(): void {
    const { labels, counts, cumulatives, camerasCounts, cumulativeCamerasData } = this.projectsByMonth;

    const data: Plotly.Data[] = [
      {
        x: labels,
        y: counts,
        type: 'bar',
        name: 'Nombre de projets par mois',
        marker: {
          color: '#5fc9e4',
        },
        yaxis: 'y2', // Associe ce tracé au deuxième axe y
      },
      {
        x: labels,
        y: camerasCounts, // Ajout de la barre des caméras
        type: 'bar',
        name: 'Nombre de caméras par mois',
        marker: { color: '#4dffcd' },
        yaxis: 'y2',
      },
      {
        x: labels,
        y: cumulatives,
        type: 'scatter',
        mode: 'lines+markers',
        name: 'Cumul des projets',
        line: { color: '#5fc9e4' },
        yaxis: 'y', // Associe ce tracé au premier axe y
      },
      {
        x: labels,
        y: cumulativeCamerasData,
        type: 'scatter',
        mode: 'lines+markers',
        name: 'Cumul des caméras',
        line: { color: '#4dffcd', dash: 'dot' },
        yaxis: 'y',
      },
    ];

    const layout = {
      titlefont: { color: '#5fc9e4' },
      modebar: {
        orientation: 'v',
        bgcolor: '#001a35',
        color: '#6c757d',
        activecolor: '#5fc9e4',
      },
      xaxis: {
        title: { text: 'Mois', font: { color: '#5fc9e4' } },
        gridcolor: '#314a644a',
        linecolor: '#314a644a',
        color: '#5fc9e4',
        range: [0, labels.length - 0.2],
      },
      yaxis: {
        title: { text: 'Cumul des projets', font: { color: '#5fc9e4' } },
        gridcolor: '#314a644a',
        side: 'right',
        color: '#5fc9e4',
        range: [0, Math.max(...cumulatives, ...cumulativeCamerasData)],
      },
      yaxis2: {
        title: { text: 'Nombre de projets par mois', font: { color: '#4dffcd' } },
        overlaying: 'y', // Superpose cet axe sur y
        side: 'left', // Positionne cet axe à droite
        showgrid: false, // Masque les grilles de cet axe
        color: '#4dffcd',
        range: [0, Math.max(...counts, ...camerasCounts)],
      },
      legend: {
        orientation: 'h', // Légendes horizontales
        x: 0, // Alignement à gauche
        y: 1.1, // Position au-dessus du graphique
      },
      barmode: 'group',
      paper_bgcolor: 'rgba(0,0,0,0)', // Fond transparent
      plot_bgcolor: 'rgba(0,0,0,0)',
    } as Partial<Plotly.Layout>;

    Plotly.newPlot('project-graph', data, layout);
  }

  private loadMoreProjects(): void {
    this.displayedProjectsCount += 2; // Charger 20 projets supplémentaires
  }

  private checkScroll(): void {
    const threshold = 100; // 100 pixels avant d'atteindre le bas
    const position = window.innerHeight + window.scrollY;
    const height = document.body.offsetHeight;

    if (position >= height - threshold) {
      this.loadMoreProjects();
    }
  }

  private onOwnerChange(selectedOwnerId: string | null) {
    this.selectedOwner = selectedOwnerId;
    this.displayedProjectsCount = 20; // Réinitialiser le nombre de projets affichés
    this.updateProjectsAndMap();
  }

  private calculateCardsPerRow(): number {
    let windowWidth = window.innerWidth;

    if (windowWidth <= 800) {
      // pour écrans xs
      return 1;
    } else if (windowWidth <= 1000) {
      // pour écrans sm
      return 2;
    } else if (windowWidth <= 1500) {
      // pour écrans md
      return 3;
    } else if (windowWidth <= 2500) {
      // pour écrans md
      return 4;
    } else {
      // pour écrans lg et plus
      return 5;
    }
  }

  private onFilterChange(value: FilterType) {
    if (value === FilterType.All) {
      this.projects = this.allProject.slice(0);
    } else if (value === FilterType.Active) {
      this.projects = this.allProject.filter((project) =>
        project.cameras.some((camera) => camera.apiFetchInterval !== -1)
      );
    } else if (value === FilterType.Inactive) {
      this.projects = this.allProject.filter((project) =>
        project.cameras.every((camera) => camera.apiFetchInterval === -1)
      );
    } else if (value === FilterType.NoPhoto48) {
      const threshold = Date.now() - 48 * 60 * 60 * 1000; // 48 hours ago
      this.projects = this.allProject.filter((project) =>
        project.cameras.some((camera) => {
          if (camera.apiFetchInterval !== -1 && camera.lastPhoto?.createdAt) {
            return new Date(camera.lastPhoto.createdAt).getTime() < threshold;
          } else {
            return false; // or true, depending on your logic
          }
        })
      );
    }
    this.onSortChange(this.sort);
  }

  private mounted() {
    window.addEventListener('resize', this.handleResize);
    this.oldSelected = [...this.selectedTypes];
    window.addEventListener('scroll', this.checkScroll);
    this.onSearchChange('', '');
    this.calculateMapBounds();
    this.updateProjectsAndMap();
    window.addEventListener('resize', () => {
      this.cardsPerRow = this.calculateCardsPerRow();
    });
    this.showPopup;
    this.$nextTick(() => {
      setTimeout(() => {
        if (localStorage.getItem('tourIgnored')) {
          return;
        }
        if (window.innerWidth >= 700) {
          const tour = new Shepherd.Tour({
            defaultStepOptions: {
              cancelIcon: {
                enabled: true,
              },
              classes: 'shepherd-content', // Ajoutez votre propre classe CSS
              scrollTo: true,
              when: {
                show() {
                  const currentStep = Shepherd.activeTour?.getCurrentStep();
                  if (!currentStep) return;
                  const currentStepElement = currentStep.getElement();
                  if (!currentStepElement) return;
                  const header = currentStepElement.querySelector('.shepherd-footer');
                  if (!header) return;
                  const progress = document.createElement('div');
                  const innerBar = document.createElement('span');
                  const progressPercentage = ((tour.steps.indexOf(currentStep) + 1) / tour.steps.length) * 100 + '%';
                  progress.className = 'shepherd-progress-bar';
                  innerBar.style.width = progressPercentage;
                  if (document.getElementsByClassName('shepherd-button').length == 1) {
                    progress.style.minWidth = '260px';
                  }
                  progress.appendChild(innerBar);
                  const headerh = currentStepElement.querySelector('.shepherd-header');
                  const progressh = document.createElement('span');
                  progressh.style.marginRight = '0px';
                  progressh.innerText = `${tour.steps.indexOf(currentStep) + 1}/${tour.steps.length}`;
                  if (headerh) {
                    headerh.insertBefore(progressh, currentStepElement.querySelector('.shepherd-cancel-icon'));
                  }
                  header.insertBefore(progress, currentStepElement.querySelector('.shepherd-button'));
                },
              },
            },
            useModalOverlay: true,
            keyboardNavigation: false,
          });

          tour.addStep({
            title: this.$t('projectlist.step1title').toString(),
            text: this.$t('projectlist.step1text').toString(),
            attachTo: {
              element: 'nothing', // La classe CSS d  e l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: () => {
                  localStorage.setItem('tourIgnored', 'true');
                  tour.complete();
                },
                text: this.$t('projectlist.donotshow').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
          });
          tour.addStep({
            title: this.$t('projectlist.step2title').toString(),
            text: this.$t('projectlist.step2text').toString(),
            attachTo: {
              element: 'nothing', // La classe CSS de l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: () => {
                  localStorage.setItem('tourIgnored', 'true');
                  tour.complete();
                },
                text: this.$t('projectlist.donotshow').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
          });
          tour.addStep({
            title: this.$t('projectlist.step3title').toString(),
            text: this.$t('projectlist.step3text').toString(),
            attachTo: {
              element: '.searchproject', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
          });

          tour.addStep({
            title: this.$t('projectlist.step4title').toString(),
            text: this.$t('projectlist.step4text').toString(),
            attachTo: {
              element: '.diffvue', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: function () {
                  let gripElement = document.querySelector('.fa-grip');
                  if (gripElement) {
                    (gripElement as HTMLElement).click();
                  }
                  setTimeout(function () {
                    tour.next();
                  }, 100);
                },
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
            },
          });
          tour.addStep({
            title: this.$t('projectlist.step5title').toString(),
            text: this.$t('projectlist.step5text').toString(),
            attachTo: {
              element: '.vuezoom', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            advanceOn: { selector: '.vuemap', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 11, crossAxis: 0 })],
            },
          });
          tour.addStep({
            title: this.$t('projectlist.step6title').toString(),
            text: this.$t('projectlist.step6text').toString(),
            attachTo: {
              element: '.projetcarte', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          tour.addStep({
            title: this.$t('projectlist.step61title').toString(),
            text: this.$t('projectlist.step61text').toString(),
            attachTo: {
              element: '.invite', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            advanceOn: { selector: '.picto-settings', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          tour.addStep({
            title: this.$t('projectlist.step62title').toString(),
            text: this.$t('projectlist.step62text').toString(),
            attachTo: {
              element: '.picto-settings', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: function () {
                  // Aller directement à l'étape 10 (index 9)
                  tour.show(11);
                },
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            advanceOn: { selector: '.picto-settings', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          tour.addStep({
            title: this.$t('projectlist.step7title').toString(),
            text: this.$t('projectlist.step7text').toString(),
            attachTo: {
              element: '.description', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: function () {
                  // Déclenche un clic sur l'élément de classe '.close'
                  let closeElement = document.querySelector('.close');
                  if (closeElement) {
                    (closeElement as HTMLElement).click();
                  }
                  tour.back();
                },
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            advanceOn: { selector: '.picto-settings', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 70, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          tour.addStep({
            title: this.$t('projectlist.step8title').toString(),
            text: this.$t('projectlist.step8text').toString(),
            attachTo: {
              element: '.col-12', // La classe CSS de l'élément que vous voulez souligner
              on: 'top',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            advanceOn: { selector: '.picto-settings', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          tour.addStep({
            title: this.$t('projectlist.step9title').toString(),
            text: this.$t('projectlist.step9text').toString(),
            attachTo: {
              element: '.iframe', // La classe CSS de l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: function () {
                  // Déclenche un clic sur l'élément de classe '.close'
                  let closeElement = document.querySelector('.close');
                  if (closeElement) {
                    (closeElement as HTMLElement).click();
                  }
                  tour.next();
                },
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            advanceOn: { selector: '.picto-settings', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          tour.addStep({
            title: this.$t('projectlist.step10title').toString(),
            text: this.$t('projectlist.step10text').toString(),
            attachTo: {
              element: '.projetcarte', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: function () {
                  // Aller directement à l'étape 10 (index 9)
                  tour.show(6);
                },
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: () => {
                  localStorage.setItem('tourIgnored', 'true');
                  tour.complete();
                },
                text: this.$t('projectlist.donotshow').toString(),
                classes: 'shepherd-button-ignore',
              },
            ],
            advanceOn: { selector: '.projetcarte', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          if (!window.location.pathname.endsWith('/login')) {
            tour.start();
          }
        }
      }, 2000);
    });
    this.intervalId = setInterval(() => {
      this.fetchProjects(); // mise à jour des projets sans recharger toute la page
    }, 300000); // 5 minutes
  }

  private handleResize(): void {
    this.windowWidth = window.innerWidth;
  }

  private get projectsWithLastPhotoDate(): Project[] {
    return this.displayedProjectsForList.map((project) => {
      let latestDate: Date | null = null;
      project.cameras.forEach((camera) => {
        if (camera.lastPhoto && camera.lastPhoto.createdAt) {
          const photoDate =
            camera.lastPhoto.createdAt instanceof Date
              ? camera.lastPhoto.createdAt
              : new Date(camera.lastPhoto.createdAt);
          if (!latestDate || photoDate > latestDate) {
            latestDate = photoDate;
          }
        }
      });
      return { ...project, lastPhotoDate: latestDate ? latestDate : 'Pas de photo' };
    });
  }

  get searchLabel(): string {
    // Vous devez définir la clé 'projectlist.searchMobile' dans vos fichiers de traduction
    return this.windowWidth < 600
      ? this.$t('projectlist.searchMobile').toString()
      : this.$t('projectlist.search').toString();
  }

  public startTour(): void {
    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        cancelIcon: {
          enabled: true,
        },
        classes: 'shepherd-content', // Ajoutez votre propre classe CSS
        scrollTo: true,
        when: {
          show() {
            const currentStep = Shepherd.activeTour?.getCurrentStep();
            if (!currentStep) return;
            const currentStepElement = currentStep.getElement();
            if (!currentStepElement) return;
            const header = currentStepElement.querySelector('.shepherd-footer');
            if (!header) return;
            const progress = document.createElement('div');
            const innerBar = document.createElement('span');
            const progressPercentage = ((tour.steps.indexOf(currentStep) + 1) / tour.steps.length) * 100 + '%';
            progress.className = 'shepherd-progress-bar';
            innerBar.style.width = progressPercentage;
            if (document.getElementsByClassName('shepherd-button').length == 1) {
              progress.style.minWidth = '260px';
            }
            progress.appendChild(innerBar);
            const headerh = currentStepElement.querySelector('.shepherd-header');
            const progressh = document.createElement('span');
            progressh.style.marginRight = '0px';
            progressh.innerText = `${tour.steps.indexOf(currentStep) + 1}/${tour.steps.length}`;
            if (headerh) {
              headerh.insertBefore(progressh, currentStepElement.querySelector('.shepherd-cancel-icon'));
            }
            header.insertBefore(progress, currentStepElement.querySelector('.shepherd-button'));
          },
        },
      },
      useModalOverlay: true,
      keyboardNavigation: false,
    });

    tour.addStep({
      title: this.$t('projectlist.step1title').toString(),
      text: this.$t('projectlist.step1text').toString(),
      attachTo: {
        element: 'nothing', // La classe CSS d  e l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: () => {
            localStorage.setItem('tourIgnored', 'true');
            tour.complete();
          },
          text: this.$t('projectlist.donotshow').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
    });
    tour.addStep({
      title: this.$t('projectlist.step2title').toString(),
      text: this.$t('projectlist.step2text').toString(),
      attachTo: {
        element: 'nothing', // La classe CSS de l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: () => {
            localStorage.setItem('tourIgnored', 'true');
            tour.complete();
          },
          text: this.$t('projectlist.donotshow').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
    });
    tour.addStep({
      title: this.$t('projectlist.step3title').toString(),
      text: this.$t('projectlist.step3text').toString(),
      attachTo: {
        element: '.searchproject', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
      },
    });

    tour.addStep({
      title: this.$t('projectlist.step4title').toString(),
      text: this.$t('projectlist.step4text').toString(),
      attachTo: {
        element: '.diffvue', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: function () {
            let gripElement = document.querySelector('.fa-grip');
            if (gripElement) {
              (gripElement as HTMLElement).click();
            }
            setTimeout(function () {
              tour.next();
            }, 100);
          },
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
      },
    });
    tour.addStep({
      title: this.$t('projectlist.step5title').toString(),
      text: this.$t('projectlist.step5text').toString(),
      attachTo: {
        element: '.vuezoom', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      advanceOn: { selector: '.vuemap', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 11, crossAxis: 0 })],
      },
    });
    tour.addStep({
      title: this.$t('projectlist.step6title').toString(),
      text: this.$t('projectlist.step6text').toString(),
      attachTo: {
        element: '.projetcarte', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.addStep({
      title: this.$t('projectlist.step61title').toString(),
      text: this.$t('projectlist.step61text').toString(),
      attachTo: {
        element: '.invite', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      advanceOn: { selector: '.picto-settings', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.addStep({
      title: this.$t('projectlist.step62title').toString(),
      text: this.$t('projectlist.step62text').toString(),
      attachTo: {
        element: '.picto-settings', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: function () {
            // Aller directement à l'étape 10 (index 9)
            tour.show(11);
          },
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      advanceOn: { selector: '.picto-settings', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.addStep({
      title: this.$t('projectlist.step7title').toString(),
      text: this.$t('projectlist.step7text').toString(),
      attachTo: {
        element: '.description', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: function () {
            // Déclenche un clic sur l'élément de classe '.close'
            let closeElement = document.querySelector('.close');
            if (closeElement) {
              (closeElement as HTMLElement).click();
            }
            tour.back();
          },
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      advanceOn: { selector: '.picto-settings', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 70, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.addStep({
      title: this.$t('projectlist.step8title').toString(),
      text: this.$t('projectlist.step8text').toString(),
      attachTo: {
        element: '.col-12', // La classe CSS de l'élément que vous voulez souligner
        on: 'top',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      advanceOn: { selector: '.picto-settings', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.addStep({
      title: this.$t('projectlist.step9title').toString(),
      text: this.$t('projectlist.step9text').toString(),
      attachTo: {
        element: '.iframe', // La classe CSS de l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: function () {
            // Déclenche un clic sur l'élément de classe '.close'
            let closeElement = document.querySelector('.close');
            if (closeElement) {
              (closeElement as HTMLElement).click();
            }
            tour.next();
          },
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      advanceOn: { selector: '.picto-settings', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.addStep({
      title: this.$t('projectlist.step10title').toString(),
      text: this.$t('projectlist.step10text').toString(),
      attachTo: {
        element: '.projetcarte', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: function () {
            // Aller directement à l'étape 10 (index 9)
            tour.show(6);
          },
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: () => {
            localStorage.setItem('tourIgnored', 'true');
            tour.complete();
          },
          text: this.$t('projectlist.donotshow').toString(),
          classes: 'shepherd-button-ignore',
        },
      ],
      advanceOn: { selector: '.projetcarte', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.start();
  }

  public showPopup(project: Project) {
    console.log(`Affichage du popup pour le projet ${project.id}`);
    this.preloadImages()
      .then(() => {
        // Toutes les images sont préchargées, maintenant vous pouvez afficher le popup
        this.loadImage(project);
        let popupRef = this.$refs['popup-' + project.id] as any[];
        if (popupRef.length > 0) {
          let leafletPopup = popupRef[0] as any;
          leafletPopup.mapObject.openPopup();
        }
      })
      .catch((error) => {
        console.error('Erreur lors du préchargement des images:', error);
      });
  }
  public preloadImages(): Promise<void[]> {
    const imagePromises: Promise<void>[] = [];
    for (const projectId in this.imageUrls) {
      const imageUrl = this.imageUrls[projectId];
      const imagePromise = new Promise<void>((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve();
        image.onerror = () => reject(new Error(`Erreur de chargement de l'image ${imageUrl}`));
        image.src = imageUrl;
      });
      imagePromises.push(imagePromise);
    }
    return Promise.all(imagePromises).catch((error) => {
      console.error('Erreur lors du préchargement des images:', error);
      throw error; // Nous lançons l'erreur à nouveau pour que la fonction appelante puisse la gérer si nécessaire
    });
  }

  public loadImage(project: Project) {
    if (project.lastPhoto?.smallKey && !this.imageUrls[project.id]) {
      const key = project.lastPhoto.smallKey;
      Storage.get(key).then((url) => {
        this.$set(this.imageUrls, project.id, url) as string;
      });
    } else if (this.imageUrls[project.id]) {
      console.log(`L'image pour le projet ${project.id} est déjà chargée: ${this.imageUrls[project.id]}`); // Ajout d'un log si l'image est déjà chargée
    } else {
      console.log(`Aucune image à charger pour le projet ${project.id}`); // Ajout d'un log si il n'y a pas d'image à charger
    }
  }

  beforeDestroy() {
    // Enlever l'écouteur d'événement au moment de la destruction du composant
    window.removeEventListener('scroll', this.checkScroll);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('resize', () => {
      this.cardsPerRow = this.calculateCardsPerRow();
    });
    document.removeEventListener('click', this.handleClickOutside);
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private async fetchProjects() {
    try {
      await this.$store.dispatch('projects/loadProject');
      const updatedProjects = [...this.$store.state.projects.projects];
      this.projects = updatedProjects;
      this.updateProjectsAndMap();
      this.updateKey++; // Incrémenter à chaque mise à jour
    } catch (error) {
      console.error('Erreur lors du chargement des projets:', error);
    }
  }

  private incrementCardsPerRow() {
    if (this.cardsPerRow < 6) {
      this.cardsPerRow++;
    }
  }

  private decrementCardsPerRow() {
    if (this.cardsPerRow > 1) {
      this.cardsPerRow--;
    }
  }

  public get breadcrumbs(): unknown[] {
    return [
      {
        text: this.$tc('global.project', 2),
        to: '#',
      },
    ];
  }

  public get listMode(): string | null {
    return (this.$route.query.listMode as string) || 'mosaic';
  }

  public set listMode(listMode: string | null) {
    if (listMode === null || listMode === 'mosaic') {
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, listMode: undefined } });
    } else {
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, listMode } });
    }
  }

  private formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 car les mois vont de 0 à 11
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
  }

  private async updateProjectsAndMap() {
    let updatedProjects: Project[] = [];

    if (this.selectedOwner) {
      if (this.selectedOwner === 'others') {
        const excludedIds = [
          'd71996b1-800f-4ec8-8f20-c1a341198f62',
          '5a308ace-0010-404d-9b75-b68d60cf0526',
          '2048cf37-41ca-4b54-8bee-66d963d57f98',
          'f55592f0-cda7-4243-8fc5-add96d5d53db',
        ];
        updatedProjects = this.allProject.filter((project) => project.owner && !excludedIds.includes(project.owner.id));
      } else {
        updatedProjects = this.allProject.filter((project) => project.owner && project.owner.id === this.selectedOwner);
      }
    } else {
      updatedProjects = this.search ? this.filterProject(this.search) : [...this.allProject];
    }

    this.onSortChange(this.sort);
    // Forcer la réactivité avec une nouvelle référence
    this.projects = [...updatedProjects];
    await this.$nextTick();
    this.calculateMapBounds();
  }

  public get isSmallScreen(): boolean {
    return window.innerWidth < 500;
  }

  @Watch('imageUrls', { deep: true, immediate: true })
  onImageUrlsChange() {
    this.$forceUpdate();
  }

  @Watch('search')
  private onSearchChange(val: string, oldVal: string) {
    if (val === '') {
      this.projects = this.allProject.slice(0);
    } else {
      this.projects = this.filterProject(val);
    }
    this.onSortChange(this.sort);
    this.resetDisplayedProjectsCount();
    this.updateProjectsAndMap();
  }

  @Watch('allProject')
  private onAllProjectChange(val: Project[], oldVal: Project[]) {
    this.onSearchChange(this.search, this.search);
    this.resetDisplayedProjectsCount();
    this.updateProjectsAndMap();
  }

  @Watch('projects')
  private onProjectsChange() {
    this.calculateMapBounds();
  }

  private switchToListMode() {
    this.listMode = 'list';
  }

  private switchToGridMode() {
    this.listMode = 'mosaic';
  }

  private onSortChange(value: SortType) {
    if (value === SortType.Recent) {
      this.projects = this.projects.sort((a: Project, b: Project) => {
        return b.createdAt.getTime() - a.createdAt.getTime();
      });
    } else {
      this.projects = this.projects.sort((a: Project, b: Project) => {
        if (a.city?.name !== undefined && b.city?.name !== undefined) {
          return a.city.name.localeCompare(b.city.name);
        } else if (a.city !== undefined) {
          return -1;
        } else if (b.city !== undefined) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }

  private isAdmin(project: Project) {
    return (
      this.user !== undefined &&
      (project?.owner?.id === this.user?.id || project.administratorId.includes(this.user.id))
    );
  }

  public viewProject(project: Project) {
    // Naviguer vers la page correspondant au projet dans un nouvel onglet
    const route = this.$router.resolve({ name: 'plateformcentral', params: { id: project.id } });
    window.open(route.href, '_blank');
  }

  private async calculateMapBounds() {
    if (this.projects.length === 0) {
      return;
    }

    const latitudes = this.projects.map((project) => project.city.latlng.lat);
    const longitudes = this.projects.map((project) => project.city.latlng.lng);

    const minLat = Math.min(...latitudes);
    const maxLat = Math.max(...latitudes);
    const minLng = Math.min(...longitudes);
    const maxLng = Math.max(...longitudes);

    const centerLat = (minLat + maxLat) / 2;
    const centerLng = (minLng + maxLng) / 2;

    const paddingFactor = 0.1;

    const bounds = new L.LatLngBounds([minLat, minLng], [maxLat, maxLng]).pad(paddingFactor);

    this.center = [centerLat, centerLng];

    const map = this.$refs.map as any;
    map.fitBounds(bounds); // Mise à jour du zoom en ajustant les limites de la carte

    // Décommentez la ligne suivante si vous souhaitez également mettre à jour le zoom manuellement
    // this.zoom = map.getZoom();
  }

  private toggleSatelliteView() {
    this.satelliteView = !this.satelliteView;
    if (this.satelliteView) {
      this.url = 'http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}';
    } else {
      this.url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    }
  }
}
